import * as Data from './Data';
import * as Service from '@/App/Service';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

/**
 * Whether refresh manager has been initialized
 *
 * @type boolean
 */
let hasInitialized: boolean = false;

/**
 * Initialize refresh listeners.
 *
 * @return void
 */
export function initialize(): void {
	if (hasInitialized) {
		return;
	}

	if (Capacitor.isNativePlatform()) {
		App.addListener('resume', () => {
			Data.refreshAllData();
			Service.PushNotification.refreshRegistration();
		});
	} else {
		document.addEventListener('visibilitychange', async () => {
			if (document.visibilityState === 'visible') {
				Data.refreshAllData();
				Service.PushNotification.refreshRegistration();
			}
		});
	}

	hasInitialized = true;
}
